import angular from 'angular';
import '../runner.services/creation-hub.service';

const runnerCreationHubModule = angular.module(
  'flowingly.runner.creation-hub',
  []
);

export { runnerCreationHubModule };
